import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: "https://auth.alphy.pro",
  realm: "alphy_datagreffe",
  clientId: "devpospartner",
});

export default keycloak;